// extracted by mini-css-extract-plugin
export default {"bell":"Bell_bell__VvOXl","iconBellWrapper":"Bell_iconBellWrapper__VS0EF","iconBell":"Bell_iconBell__dBc54","iconGreenCircle":"Bell_iconGreenCircle__xL3TQ"};